import { useRef, useCallback, useEffect } from 'react';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';

const MARGIN = 16;
const MIN_SIZE = 200;

const getMaxWidth = (width: number) =>
  Math.max(Math.floor(width) - MARGIN, MIN_SIZE);

const useDropdownContentSize = (dropdown?: DropdownRef | null) => {
  const dropdownContentRef = useRef<HTMLDivElement>(null);

  const updateMaxSizes = useCallback(() => {
    const el = dropdownContentRef?.current;

    if (!el) return;

    const rect = el.getBoundingClientRect();

    const availableHeight = dropdown?.isUpwards
      ? rect.bottom
      : window.innerHeight - rect.top;

    if (availableHeight)
      el.style.maxHeight = `${getMaxWidth(availableHeight)}px`;

    const availableWidth = dropdown?.isBackwards
      ? rect.right
      : window.innerWidth - rect.left;

    if (availableWidth) el.style.maxWidth = `${getMaxWidth(availableWidth)}px`;
  }, [dropdown]);

  useEffect(() => {
    if (!dropdown?.isOpen) return;

    updateMaxSizes();

    window.addEventListener('resize', updateMaxSizes);
    window.addEventListener('scroll', updateMaxSizes, true);

    return () => {
      window.removeEventListener('resize', updateMaxSizes);
      window.removeEventListener('scroll', updateMaxSizes, true);
    };
  }, [dropdown, updateMaxSizes]);

  return { dropdownContentRef };
};

export default useDropdownContentSize;
